import React, { useEffect, useId, useRef } from 'react';

export default function AdminDeleteProspectDialog({
  open,
  address,
  t,
  saving,
  error,
  onCancel,
  onConfirm,
}) {
  const titleId = useId();
  const descId = useId();
  const cancelRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const id = window.setTimeout(() => cancelRef.current?.focus(), 0);
    const onKeyDown = (event) => {
      if (event.key === 'Escape' && !saving) {
        event.preventDefault();
        onCancel?.();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.clearTimeout(id);
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [open, saving, onCancel]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      aria-describedby={descId}
    >
      <div className="w-full max-w-md rounded-xl bg-white p-5 shadow-lg">
        <h2 id={titleId} className="text-lg font-semibold text-slate-900">
          {t('admin.prospection.delete.title')}
        </h2>
        <p id={descId} className="mt-3 text-sm text-slate-700">
          {t('admin.prospection.delete.body')}
        </p>
        {address ? (
          <p className="mt-2 break-words text-sm font-medium text-slate-900">{address}</p>
        ) : null}
        {error ? (
          <p className="mt-3 text-sm text-red-700" role="alert">
            {error}
          </p>
        ) : null}
        <div className="mt-5 flex flex-wrap justify-end gap-2">
          <button
            ref={cancelRef}
            type="button"
            className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-60"
            disabled={saving}
            onClick={onCancel}
          >
            {t('admin.prospection.delete.cancel')}
          </button>
          <button
            type="button"
            className="rounded-lg bg-red-600 px-3 py-2 text-sm font-semibold text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:opacity-60"
            disabled={saving}
            onClick={onConfirm}
          >
            {saving ? t('admin.prospection.delete.deleting') : t('admin.prospection.delete.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}
